import { createSlice } from "@reduxjs/toolkit";

export const createAccountSlice = createSlice({
  name: "createAccount",
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startCreateAccount: (state) => { state.isLoading = true; },
    setCreateAccount: (state, { payload: { data = null, error = null }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startCreateAccount, setCreateAccount } = createAccountSlice.actions;
